import { Box } from '@chakra-ui/react';

import { HOUR_PX } from 'components/ProviderHome/constants';

export const CurrentTimeIndicator = ({
  now,
  scrollRef,
}: {
  now: number;
  scrollRef: React.RefObject<HTMLDivElement>;
}) => {
  const nowDate = new Date(now);
  const topOffset =
    nowDate.getHours() * HOUR_PX +
    (nowDate.getMinutes() * HOUR_PX) / 60 +
    HOUR_PX / 2;

  return (
    <Box
      ref={scrollRef}
      position={'absolute'}
      top={`${topOffset}px`}
      left={20}
      right={8}
      height={'2px'}
      bg={'squash'}
      zIndex={1}
    >
      <Box
        position={'absolute'}
        left={0}
        top={'-3px'}
        w={'8px'}
        h={'8px'}
        borderRadius={'full'}
        bg={'squash'}
      />
    </Box>
  );
};

export default CurrentTimeIndicator;
